
const CUSTOM = 'custom';
const DEVELOPMENT = 'development';
const PRODUCTION = 'production';

export default {
    CUSTOM,
    DEVELOPMENT,
    PRODUCTION
};
